import { createColumnHelper } from '@tanstack/react-table'
import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { USER_STATUS } from '../../../config/constants'
import { useEffect, useRef, useState } from 'react'

import '../UserTable.css'
import { usePagination } from '../../../components/Table/usePagination'
import { useSorting } from '../../../components/Table/useSorting'
import { Table } from '../../../components/Table/Table'
import { approveUsers, fetchUsers, searchUsers, useGetUserAPI } from '../UsersApi'

import check_img from '../images/check.svg'
import reject_img from '../images/x.svg'

import { toast } from 'react-toastify'
import { setLoading } from '../../../services/global/globalSlice'
import UserModal from './UserModal'
import IndeterminateCheckbox from '../../../components/Table/Checkbox'


export default function UserTable(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    
    const columnHelper = createColumnHelper()

    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [loadingData, setLoadingData] = useState(false);
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [searchFilter, setSearchFilter] = useState("")
    const [selectedUser, setSelectedUser] = useState(null)
    const tableRef = useRef()

    // Make some columns!
    const defaultColumns = [
        {
            id: 'select',
            header: ({ table }) => (
            <IndeterminateCheckbox
                {...{
                id: 'all_checkbox',
                checked: table.getIsAllRowsSelected(),
                indeterminate: table.getIsSomeRowsSelected(),
                onChange: table.getToggleAllRowsSelectedHandler(),
                }}
            />
            ),
            cell: ({ row }) => (
            <div className="px-1">
                <IndeterminateCheckbox
                {...{
                    id: row.id,
                    checked: row.getIsSelected(),
                    disabled: !row.getCanSelect(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                }}
                />
            </div>
            ),
        },
    // Display Column
        columnHelper.accessor('email', {
            cell: user => user.getValue(),
            header: () => <span>E-Mail</span>
        }),
        columnHelper.accessor('firstname', {
            cell: user => user.getValue(),
            header: () => <span>{t.users.fields.firstname}</span>
        }),
        columnHelper.accessor('lastname', {
            cell: user => user.getValue(),
            header: () => <span>{t.users.fields.lastname}</span>
        }),
        columnHelper.accessor(row => row.state, {
            id: 'status',
            cell: user =><div>
                { user.getValue() === "waiting_admin_check" ?   
                    <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                        <div className='d-flex' onClick={()=>handleConfirmUsers(user)}>
                            <img src={check_img} />
                            {t.users.accept}
                        </div>
                        <div className='d-flex ms-3 pointer' style={{color:"#181818",fontWeight:"500"}}>
                            <img src={reject_img} onClick={()=>handleRejectUsers(user)} />
                            {t.users.reject}
                        </div>
                    </div>      
                : <span className='status_label' style={{color:`${USER_STATUS[user.getValue()]?.color}`, background: `${USER_STATUS[user.getValue()]?.background}`}}>{t.users.status[user.getValue()]}</span> }
            </div>,
            header: () => <span>{t.users.fields.status}</span>
        }),
        columnHelper.accessor(row => row.groups, {
            id: 'groups',
            cell: user =><span>{user.getValue()?.length} gruppi</span>,
            header: () => <span>{t.users.fields.groups}</span>
        }),
        columnHelper.accessor(row => row.last_online_date, {
            id: 'last_online_date',
            cell: user =><span>{new Date(user.getValue()).toLocaleDateString()}</span>,
            header: () => <span>{t.users.fields.last_online_date}</span>
        }),
    ]

    const { limit, onPaginationChange, skip, pagination } = usePagination();

    const { sorting, onSortingChange, field, order } = useSorting();

    const [rowSelection, setRowSelection] = useState({})

    const pageCount =  Math.round(count / limit);
    console.log(count, limit);
    

    const handleConfirmUsers = async (user) => {
        const users_id = []
        if(user) {
            if(user.getValue()==="waiting_admin_check")
                users_id.push(user.row.id)
        } else 
            users_id = Object.keys(rowSelection)

        if(users_id.length > 0){
            dispatch(setLoading(true))
            const users_data = {
                users_ids : users_id
            }
            const response = await approveUsers(users_data)
            if(response.success){
                toast.success(t.users.approve_succes)
                dispatch(setLoading(false))
                setLoadingData(true);
                const res = fetchData()
                res.then((_response) => {
                    if(_response.success && _response?.data?.length > 0){
                        setData(_response?.data);
                        setCount(count + _response?.data?.length);
                        setCanLoadMore(true);
                        setLoadingData(false);
                    } else {
                        tableRef?.current?.setPageIndex(pagination.pageIndex -1)
                        setCanLoadMore(false);
                    }
                });
            } else {
                toast.error(t.users.error_while_approving)
                dispatch(setLoading(false))
            }
        }
    }

    const handleRejectUsers = async () => {
        dispatch(setLoading(true))
        const users_id = Object.keys(rowSelection)
        const users_data = {
            users_ids : users_id
        }
        const response = await approveUsers(users_data)
        if(response.success){
            toast.success(t.users.approve_succes)
            dispatch(setLoading(false))
            setLoadingData(true);
            const res = fetchData()
            res.then((_response) => {
                if(_response.success && _response?.data?.length > 0){
                    setData(_response?.data);
                    setCount(_response?.data?.length % limit === 0 ? skip + limit : count + _response?.data?.length);
                    setCanLoadMore(_response?.data?.length % limit === 0 ? true : false);
                    setLoadingData(false);
                } else {
                    tableRef?.current?.setPageIndex(pagination.pageIndex -1)
                    setCanLoadMore(false);
                }
            });
        } else {
            toast.error(t.users.error_while_approving)
            dispatch(setLoading(false))
        }
    }

    const handleSearchUsers = (e) => {
        e.preventDefault()
        if(searchFilter){
            setLoadingData(true);
            const res = fetchData()
            res.then((_response) => {
                if(_response.success && _response?.data?.length > 0){
                    setData(_response?.data);
                    setCount(_response?.data?.length % limit === 0 ? skip + limit : count + _response?.data?.length);
                    tableRef?.current?.setPageIndex(0)
                    setCanLoadMore(_response?.data?.length % limit === 0 ? true : false);
                    setLoadingData(false);
                } else {
                    tableRef?.current?.setPageIndex(pagination.pageIndex -1)
                    setCanLoadMore(false);
                }
            });
        }
        
    }

    const fetchData = async () => {
        if(searchFilter)
            return await searchUsers({
                ...props.defaultFilters,
                pattern: searchFilter,
                skip: 0,
                limit: limit
            });
        else    
            return await fetchUsers({
                ...props.defaultFilters,
                skip: skip || 0,
                limit: limit
            });
    }

    useEffect(() => {
        setLoading(true);
        const res = fetchData()
        res.then((_response) => {
            if(_response.success && _response?.data?.length > 0){
                setCount(_response?.data?.length % limit === 0 ? skip + limit : count + _response?.data?.length);
                setData(_response?.data);
                setCanLoadMore(_response?.data?.length % limit === 0 ? true : false);
                setLoadingData(false);
            } else {
                tableRef?.current?.setPageIndex(pagination.pageIndex -1)
                setCanLoadMore(false);
            }
        });
    }, [limit, skip, field, order, setData]);

    useEffect(() => {
        setLoading(true);
        const res = fetchData()
        res.then((_response) => {
            if(_response.success){
                setData(_response?.data);
                setCount(_response?.data?.length);
                tableRef?.current?.resetRowSelection(true)
                setLoadingData(false);
            }
        });
    }, [props.defaultFilters]);


    const checkValidateActions = () => {
        return data?.find(u => Object.keys(rowSelection).includes(u.user_id) && (u?.state === "active" || u?.state === "suspended"))
    }

    const onUserSelect = (e) => {
        setSelectedUser(e.id)
    }

    const onUnselectUser = (e) => {
        setSelectedUser(null)
    }

    return (
        <div>
            <div className='tableController mb-2'>
                <div className='d-flex justify-content-end pe-2'>
                    <form onSubmit={handleSearchUsers}>
                        <div id='userSearchBar'>
                            <input type='text' value={searchFilter} placeholder={t.users.search_placeholder} onChange={(e)=>setSearchFilter(e.target.value)} />
                        </div>
                    </form>                   
                </div>
                <div className='d-flex justify-content-between mb-4 pe-2'>
                    {Object.keys(rowSelection).length > 0 ?
                        <span>{Object.keys(rowSelection).length} {t.users.users_selected}</span>
                    : <span></span>}
                    {Object.keys(rowSelection).length > 0 ?
                    <>
                        { checkValidateActions() ? 
                            <></>
                        : <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                            <div className='d-flex' onClick={handleConfirmUsers}>
                                <img src={check_img} />
                                {t.users.accept_all}
                            </div>
                            <div className='d-flex ms-3 pointer' style={{color:"#181818",fontWeight:"500"}}>
                                <img src={reject_img} />
                                {t.users.reject_all}
                            </div>
                        </div>}   
                    </>  
                    : null}                      
                </div>
            </div>
            <div className='users-step-1'>
                <Table
                    ref={tableRef}
                    cols={defaultColumns}
                    data={data}
                    loading={loadingData}
                    onPaginationChange={onPaginationChange}
                    onSortingChange={onSortingChange}
                    pageCount={pageCount}
                    pagination={pagination}
                    sorting={sorting}
                    enableRowSelection={true} 
                    autoResetSelectedRows={true}
                    autoResetPageIndex={true}
                    onRowSelectionChange={setRowSelection}
                    rowSelection={rowSelection}
                    getRowId={(row)=>row.user_id}
                    canLoadMore={canLoadMore}
                    onRowClick={onUserSelect}
                />
            </div>
            {selectedUser ?
                <UserModal userId={selectedUser} onCloseModal={onUnselectUser} />
            : null}
        </div>
        
    );
}
